import React from 'react'
import { useEffect } from 'react'
import { getDeviceDetails } from '../../lib/utils'

export default function EmailRedirect() {
  const params = new URLSearchParams(window.location.search)

  useEffect(() => {
    const { type, browser, os } = getDeviceDetails()
    const platform = `${type ? `${type}_` : ''}${os ? `${os}_` : ''}${
      browser ? `${browser}` : ''
    }`
    const base64MailData = params.get('mailto')
    let mailData = decodeURIComponent(atob(base64MailData))
      .substring(7)
      .split('body=')
    if (mailData.length !== 2) {
      document.location.href = '/'
      return
    }
    mailData[1] = encodeURIComponent(`Platform: ${platform}\r\n${mailData[1]}`)
    mailData = mailData.join('body=')
    window.location.href = `mailto:${mailData}`
  }, [])
  return <div />
}
